import React, { useState, useEffect } from "react";
import { DatePicker } from 'antd';
import { BASE_URL, fromdate } from './apiConfig';
import './CommonCSS.css'
import Swal from 'sweetalert2';
import { RotateSpinner } from "react-spinners-kit";
export default function SenderSummaryReport() {

    const [guiuser, setguiuser] = useState('');
         const [distinctSeller, setdistinctSeller] = useState([]);
        const [distinctuser, setdistinctuser] = useState([]);
            const [seller, setseller] = useState('');
    const [SummaryapiData, setSummaryApiData] = useState([]);
    const [DistinctErrorCode, setDistinctErrorCode] = useState([]);
    const [showprogress, setshowprogress] = useState(false);
    const [ecodevalue, setecodevalue] = useState('');
    const [daterangevalue, setDateRangevalue] = useState('');
    const { RangePicker } = DatePicker;

    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const today = new Date();
    // Calculate yesterday's date
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Format yesterday's date as 'YYYY-MM-DD'
    const formattedYesterday = yesterday.toISOString().split('T')[0];

    // Set the state variables
    const [dateRange, setDateRange] = useState([formattedYesterday, formattedYesterday]);
    const [startDate, setStartDate] = useState(formattedYesterday);
    const [endDate, setEndDate] = useState(formattedYesterday);


    const handleDateChange = (dates) => {
        // Update the state with the date range
        setDateRangevalue(dates);
        console.log("change Range" + dates);
        console.log("daterange:" + dateRange);

        const dateOnlyStrings = dates ? dates.map((dateString) => {
            const date = new Date(dateString);
            return date.toISOString().split("T")[0] || "2023-10-01";
        }) : ["2023-10-01", "2023-10-31"];

        let [sDate, eDate] = dateOnlyStrings;

        // Add one day to both start date and end date
        if (sDate) {
            const startDate = new Date(sDate);
            startDate.setDate(startDate.getDate() + 1);
            sDate = startDate.toISOString().split("T")[0];
        }

        if (eDate) {
            const endDate = new Date(eDate);
            endDate.setDate(endDate.getDate() + 1);
            eDate = endDate.toISOString().split("T")[0];
        }

        setStartDate(sDate);
        setEndDate(eDate);

        console.log("Inside start change:" + sDate);
        console.log("Inside end change:" + eDate);


    };

    const CallDistinctErrorCode = async () => {

        try {
            setshowprogress(true);
            const apiUrl = `${BASE_URL}/DistinctErrorCode`;
            const requestBody = {
                guiuserid: sessionusertype === 1 ? sessionusername : guiuser,
            };
            const fetchOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify(requestBody),
            };

            const response = await fetch(apiUrl, fetchOptions);
            if (!response.ok) {
                setshowprogress(false);
                console.log(`API request failed with status ${response.status}`);
                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: ("Request Failed with Status:" + response.status),
                    icon: 'error'
                });

                if (result.isConfirmed) {
                    setDistinctErrorCode([]);
                }
                return;
            }


            // Check if response is not empty before parsing as JSON
            const responseText = await response.text();
            let data;
            if (responseText) {
                data = JSON.parse(responseText);
            } else {
                data = [];
            }

            if (data?.length > 0) {
                setDistinctErrorCode(data);
            } else {
                setDistinctErrorCode([]);
            }
            console.log(data);
            setshowprogress(false);
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {

            }
            return;
        }
    };

    const callDistinctGUIUser = async () => {
            let usr = "";
            if (seller !== "") {
                usr = seller;
            }
    
            else {
                usr = sessionusername;
            }
            const apiUrl = `${BASE_URL}/AllUsers?uid=${usr}&fromwhere=1`;
    
            const fetchOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            };
            setshowprogress(true);
            try {
    
                const response = await fetch(apiUrl, fetchOptions);
                setshowprogress(false);
                if (!response.ok) {
                    throw new Error(`API request failed with status ${response.status}`);
                }
    
                const data = await response.json();
    
                const filteredData = data.filter(
                    (option) => String(option?.utype) === "2"
                );
    
                const filteredUserData = data.filter(
                    (option) => String(option?.utype) === "1"
                );
                console.log(data);
    
                if (seller === "") {
                    setdistinctSeller(filteredData);
                    setdistinctuser(filteredUserData);
                }
    
                else {
                    setdistinctuser(filteredUserData);
                }
            } catch (error) {
                setshowprogress(false);
                console.error("API Request Error:", error.message);
            }
        };

    const CallErrorCodeSummary = async () => {
        try {
            setshowprogress(true);
                const apiUrl = `${BASE_URL}/SenderwiseSummary`;
                const requestBody = {
                    usr: {
                        guiuserid: sessionusertype === 1 ? sessionusername : guiuser
                    },
                    senderid:"All",
                    sdate: formatDate(startDate),
                    edate: formatDate(endDate)
                };
                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(requestBody),
                };

                const response = await fetch(apiUrl, fetchOptions);
                if (!response.ok) {
                    setshowprogress(false);
                    console.log(`API request failed with status ${response.status}`);
                    setSummaryApiData([]);
                } else {
                    // Successful response logic
                    const responseText = await response.text();
                    let data;
                    if (responseText) {
                        data = JSON.parse(responseText);
                    } else {
                        data = [];
                    }

                    if (data?.length > 0) {
                        setSummaryApiData(data);
                    } else {
                        setSummaryApiData([]);
                    }
                    console.log(data);
                    setshowprogress(false);
                }
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {
                setguiuser('');
                setecodevalue('');
                setDateRange([]);
                setDateRangevalue("");
            }
            return;
        }

    };

    const CalldownloadRequestAPI = async () => {
        try {
            setshowprogress(true);
            if (!ecodevalue) {
                setshowprogress(false);
                const re = await Swal.fire({
                    title: "Value Error!",
                    text: "Please Fill Field value Error Code as field not inputted",
                    icon: "error"
                })
            }

            else {
                const apiUrl = `${BASE_URL}/DownloadRequest`;
                const requestBody = {
                    filename: "ErrorcodeSummary",
                    ecode: ecodevalue,
                    guser: {
                        requser: sessionusername,
                        guiuserid: sessionusertype === 1 ? sessionapiuser : guiuser,
                        seckey: {
                            GenertaedSkey: null
                        },
                    },
                    sdate: formatDate(startDate),
                    edate: formatDate(endDate),
                    ip: null,
                    mno: {
                        mobileno: null
                    }
                };
                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(requestBody),
                };

                const response = await fetch(apiUrl, fetchOptions);
                if (!response.ok) {
                    const errorMessage = response.statusText;
                    const responseBody = await response.text();
                    setshowprogress(false);
                    console.log(`API request failed with status ${response.status}`);
                    const result = await Swal.fire({
                        title: 'Download Request Error',
                        html: `${errorMessage}${responseBody}`,
                        icon: 'error'
                    });

                    if (result.isConfirmed) {
                        setSummaryApiData([]);
                    }
                    return;
                }

                else {
                    setshowprogress(false);
                    const result = await Swal.fire({
                        title: "Request Accepted Successfully!",
                        text: `Your Error Code Summary Download Request is Accepted Successfully.Click on Top-Right Download Icon, and will get Download Link to download once file is available for Downloads.`,
                        icon: "success"
                    });

                    if (result.isConfirmed) {
                        setSummaryApiData([]);
                        setDistinctErrorCode([]);
                        setdistinctuser([]);
                        setguiuser('');
                        setecodevalue('');
                        setDateRange([]);
                        setDateRangevalue("");
                        // Reset only when necessary
                    }
                    return;
                }
            }
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'Download request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {
                setguiuser('');
                setecodevalue('');
                setDateRange([]);
                setDateRangevalue("");
            }
            return;
        }


    };


     const loginData = JSON.parse(sessionStorage.getItem("loginData"));
      const sessionusertype = loginData?.utype?.usertype;
      const sessionusername = loginData?.guiuserid;
      const sessionapiuser = loginData?.apiuserid;
  
  
       useEffect(() => {
              if (sessionusertype !== 2) {
                  callDistinctGUIUser();
              }
          }, []);
  
          useEffect(() => {
              if (seller !== "" || sessionusertype === 2) {
                  callDistinctGUIUser();
              }
          }, [seller,sessionusertype])
  


    console.log("DIstinct Errorcode:" + DistinctErrorCode);

    const apiDataLength = SummaryapiData?.length;
    return (
        <div className="maincontent-outermost">
            <div className="div-container" style={{ position: "relative" }}>
                <div className="row-container">
                    <span>Sender Wise Summary Report</span>
                </div>

                {showprogress === true ? <div className="spinner-overlay">
                    <div className="custom-spinner"></div>
                </div> : <div></div>}

                <div className={showprogress === true ? "row-container blurred" : "row-container"}>
                                   <div className="flex-div">
                                          {sessionusertype === 0 && (
                                           <div className="medium-flex-div"  >
               
                                               <label htmlFor="apiuser" >Select Seller</label>
                                               {sessionusertype !== 1 ? (
                                                   <select
                                                       className="selectpicker form-control"
                                                       value={seller}
                                                       onChange={(e) => setseller(e.target.value)}
                                                       style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                                                   >
                                                       <option value="" disabled >Select Seller</option>
                                                       {distinctSeller?.map((option, index) => (
                                                               <option
                                                                   key={index}
                                                                   value={option?.guiuserid}
                                                                   style={{
                                                                       textOverflow: "ellipsis",
                                                                       overflowWrap: "break-word",
                                                                       overflow: "hidden",
                                                                       whiteSpace: "nowrap",
                                                                       marginLeft: "-1rem"
                                                                   }}
                                                               >
                                                                   {option?.guiuserid}
                                                               </option>
                                                           ))
                                                       }
                                                   </select>
                                               ) : (
                                                   <input type="text" className="form-control" value={sessionusername} disabled />
                                               )}
               
               
                                           </div>
                                       )}
                                         <div className={sessionusertype === 0 ? "medium-flex-div" : "bigger-flex-div"} >
                                           <label htmlFor="apiuser" >API User ID</label>
                                           {sessionusertype !== 1 ? (
                                               <select
                                                   className="selectpicker form-control"
                                                   value={guiuser}
                                                   onChange={(e) => setguiuser(e.target.value)}
                                                   style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                                               >
                                                   <option value="" disabled >Select User</option>
                                                   {distinctuser?.map((option, index) => (
                                                           <option
                                                               key={index}
                                                               value={option?.guiuserid}
                                                               style={{
                                                                   textOverflow: "ellipsis",
                                                                   overflowWrap: "break-word",
                                                                   overflow: "hidden",
                                                                   whiteSpace: "nowrap",
                                                                   marginLeft: "-1rem"
                                                               }}
                                                           >
                                                               {option?.guiuserid}
                                                           </option>
                                                       ))
                                                   }
                                               </select>
                                           ) : (
                                               <input type="text" className="form-control" value={sessionapiuser} disabled />
                                           )}
               
               
                                       </div>
               
                                        <div className={sessionusertype === 0 ? "medium-flex-div" : "bigger-flex-div"} >
                                           <label htmlFor="date" >Date Range</label>
                                           <RangePicker
                                               size="large"
                                               value={daterangevalue}
                                               className='neuromorphic-input'
                                               onChange={handleDateChange}
                                               style={{ border: "1px dotted black", width: "100%", height: "2.3rem" }}
                                               disabledDate={(current) => {
                                                   const fromDate = new Date(fromdate); // Replace with your actual fromdate
                                                   const today = new Date();
                                                   today.setHours(23, 59, 59, 999); // End of today's date
               
                                                   // Disable dates before `fromDate` and after today
                                                   return current && (current < fromDate || current > today);
                                               }}
                                           />
                                       </div>
                                   </div>
                               </div>

                <div className={showprogress === true ? "row-container blurred" : "row-container"}>

                    <div className="button-file-div mt-1">
                        <button className='btn btn-dark mt-0' onClick={CallErrorCodeSummary}  >
                            <i class="fa-solid fa-file-lines mr-2"></i>
                            <span>View Report</span></button>
                        <button className='btn btn-dark ' onClick={CalldownloadRequestAPI}>
                            <i class="fa-solid fa-download mr-1"></i> <span>Download</span></button>
                    </div>

                </div>


                <div className={showprogress === true ? "row-container blurred table-responsive " : "row-container table-responsive "}>
                    {SummaryapiData === null ? (
                        <div className="rowcontainer" style={{ justifyContent: "center" }}>
                            <div className="spinner-container">
                                <div className="spinner-overlay">
                                    <div className="custom-spinner"></div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        apiDataLength === 0 ? (
                            <div className="img-report-div mt-5">
                                <div className="img-div">
                                    <img src="images/NoReport.png" className="img-noreport" alt="No Report" />

                                </div>
                                <p style={{ marginLeft: "0rem", marginTop: "1rem", color: "grey" }}>
                                    No Report Found !!!
                                </p>
                            </div>
                        ) : (
                              <table className="table table-bordered mt-4" style={{ fontSize: "0.92rem" }}>

                                <thead style={{ backgroundColor: "skyblue" }}>
                                    <tr>
                                        <th>Date</th>
                                        <th>API User ID</th>
                                        <th>Sender ID</th>
                                        <th>Total Submit</th>
                                        <th>Total Delivered</th>
                                        <th>Total Failed</th>
                                        <th>Total Rejected</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Render rows dynamically based on the data */}
                                    {SummaryapiData?.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{item?.reqdate}</td>
                                                <td>{item?.usr?.guiuserid}</td>
                                                <td>{item?.senderid}</td>
                                                <td>{item?.totalSubmit}</td>
                                                <td>{item?.totalDelivered}</td>
                                                <td>{item?.totalFailed}</td>
                                                <td>{item?.totalRejected}</td>

                                            </tr>
                                        );
                                    })}


                                </tbody>
                            </table>
                        )
                    )}
                </div>
            </div>
        </div>
    );
}